<px-o070-pressfolder [tiles]="_tiles"></px-o070-pressfolder>
